import PriceResourceModel from '../../generated/types/model/resource/PriceResourceModel';

export default class PriceResourceViewModel extends PriceResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
